import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import TorrentIcon from "assets/icons/site/resources/Torrent"
import MagnetIcon from "assets/icons/site/resources/Magnet"
import MediafireShareFSIcon from "assets/icons/site/resources/MediaFire"
import MegaFSIcon from "assets/icons/site/resources/Mega"
import { ReactComponent as PixelDrainFsIcon } from "assets/icons/site/resources/PixelDrain.svg";
import DownloadIcon from "@mui/icons-material/Download";
import React from "react";
import { Resource } from "shared/Resource";

import MangadexLogoIcon from "assets/icons/site/resources/Mangadex";
import BatotoLogoIcon from "assets/icons/site/resources/Batoto";
import NHentaiLogoIcon from "assets/icons/site/resources/Nhentai"
import MangahereLogoIcon from "assets/icons/site/resources/mangahere-icon.png"


export type ResourceLinkProps = Resource;

const descriptions = [
  '',
  "Download a torrent file and use a bittorrent client to download ",
  "Use a magnet uri to download ",
  "From the server, directly download ",
  "From a 3rd-party filesharing service, download ",
  "On the web, without downloading, view "
];

const icons: Array<JSX.Element> = [
  <React.Fragment />,
  <TorrentIcon viewBox='0 0 6.35 6.35' />,
  <MagnetIcon />,
];

const ResourceLink = ({ kind, uri, description, missing }: ResourceLinkProps) => {
  const tooltipTitle = `${descriptions[kind]}`;
  const descriptionTags = description.split(",");
  const siteInformation = getResourceInformation(descriptionTags);

  const isDisabled = missing === true;
  const icon = kind < 4 ? icons[kind] : siteInformation.icon ;
  

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton 
        href={uri}
        size="large"
        disabled={ isDisabled }
        sx={{
          fontSize: "2rem",
          opacity: isDisabled ? .6 : 1,
          filter: `grayscale(${isDisabled ? '100%' : '0%'})`,
          "svg": {width: "2.25rem", height: "2.25rem"}
        }}
        
      >
        { icon }
      </IconButton>
    </Tooltip>
  );
};

export type SiteInformation = {
  icon: JSX.Element | null,
  name?: string | undefined;
  generalUrl?: string | undefined,
}

function getResourceInformation(tags: Array<string>): SiteInformation {
  let siteInfo: SiteInformation = {
    icon: <DownloadIcon htmlColor='#fff' />,
  }

  if (tags.includes('mega')) {
    siteInfo = {
      name: 'Mega',
      icon: <MegaFSIcon />,
      generalUrl: 'https://mega.nz',
    }
  } else if (tags.includes('mediafire')) {
    siteInfo = {
      name: 'MediaFire',
      icon: <MediafireShareFSIcon />,
      generalUrl: 'https://www.mediafire.com'
    }
  } else if (tags.includes('rapidshare.io')) {
    siteInfo = {
      name: 'Rapidshare.io',
      icon: null,
      // icon: <RapidShareLogo width={38} height={34
      generalUrl: "https://rapidshare.io",
    };
  } else if (tags.includes('pixel drain')) {
    siteInfo = {
      name: "Pixel Drain",
      icon: <PixelDrainFsIcon />,
      generalUrl: 'https://pixeldrain.com'
    };
  } else if (tags.includes('mangahere')) {
    siteInfo = {
      name: 'MangaHere',
      icon: <img src={ MangahereLogoIcon } height="100%" width="100%" alt="mangahere" />,
      generalUrl: 'https://mangahere.co'
    }
  } else if (tags.includes('mangadex')) {
    siteInfo = {
      name: "MangaDex",
      icon: <MangadexLogoIcon viewBox="0 2 40 32" />,
      generalUrl: 'https://mangadex.org'
    }
  } else if (tags.includes('bato')) {
    siteInfo = {
      name: 'Bato.to',
      icon: <BatotoLogoIcon viewBox='4 4 28 28' />,
      generalUrl: 'https://bato.to',
    }
  } else if (tags.includes('nhentai')) {
    siteInfo = {
      name: 'NHentai',
      icon: <NHentaiLogoIcon viewBox="80 175 400 270" />,
      generalUrl: 'https://nhentai.net',
    }
  }

  return siteInfo;
}


export default ResourceLink;